import React from 'react'
import { Divider, Typography } from 'antd'
import Wash_InwardedBin from '../../../../components/Wash/Report/Wash_InwardedBin/Wash_InwardedBin'

const Wash_InwardedBinPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Inward/ Outward Bin
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <Wash_InwardedBin />
        </>
    )
}

export default Wash_InwardedBinPage